<template>
    <div>
        <form class="needs-validation" v-on:submit.prevent="createBuilding" v-on:keydown="clear($event.target.name)">
            <div class="form-row">
                <div class="col-md-12 mb-3">
                    <button type="button" class="btn btn-info btn-block" v-if="!google" v-on:click="loadGoogleMaps">Find from google</button>
                    <input type="text"
                           class="form-control"
                           placeholder="Enter a location"
                           ref="googleMapInput"
                           v-bind:class="{'disabledGoogleLocationInput': !google}"
                           v-model="googleLocationInput">
                    <div class="google-map" ref="googleMap" v-bind:class="{loaded: google}"></div>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-12 mb-3">
                    <label for="name" class="sr-only">Name</label>
                    <input type="text" class="form-control" name="name" v-model="buildingInfo.name"
                           v-bind:class="{'is-invalid':error.buildingInformation.name}" placeholder="Building Name">
                    <div :class="{'invalid-feedback':response.errorMessage.name}" v-if="response.errorMessage.name">
                       {{response.errorMessage.name[0]}}
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="col-md-4 mb-3">
                    <label name="strata_no" class="sr-only">Strata No</label>
                    <input type="text" class="form-control" name="strata_no" v-model="buildingInfo.strataNo"
                           v-bind:class="{'is-invalid':error.buildingInformation.strata_no}" placeholder="Strata No">

                    <div :class="{'invalid-feedback':response.errorMessage.strata_no}" v-if="response.errorMessage.strata_no">
                        {{this.response.message}}
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label for="latitude" class="sr-only">Latitude</label>
                    <input type="text" class="form-control" name="latitude" v-model="buildingInfo.latitude"
                           v-bind:class="{'is-invalid':error.buildingInformation.latitude}" placeholder="Latitude">
                </div>
                <div class="col-md-4 mb-3">
                    <label for="Longitude" class="sr-only">Longitude</label>
                    <input type="text" class="form-control" name="longitude" v-model="buildingInfo.longitude"
                           v-bind:class="{'is-invalid':error.buildingInformation.longitude}" placeholder="Longitude">
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-12 mb-3">
                    <label for="st_address" class="sr-only">Street Address</label>
                    <input type="text" class="form-control" name="address" v-model="buildingInfo.address"
                           v-bind:class="{'is-invalid':error.buildingInformation.address}" placeholder="Street address">

                    <div :class="{'invalid-feedback':response.errorMessage.address}" v-if="response.errorMessage.address">
                        Street Address is required
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-4 mb-3">
                    <label for="suburb" class="sr-only">Suburb</label>
                    <input type="text" class="form-control" name="suburb" v-model="buildingInfo.suburb"
                           v-bind:class="{'is-invalid':error.buildingInformation.suburb}" placeholder="Suburb">

                    <div :class="{'invalid-feedback':response.errorMessage.suburb}" v-if="response.errorMessage.suburb">
                        {{response.errorMessage.suburb[0]}}
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label for="post_code" class="sr-only">Post Code</label>
                    <input type="text" class="form-control" name="post_code" v-model="buildingInfo.postCode"
                           v-bind:class="{'is-invalid':error.buildingInformation.post_code}" placeholder="Post Code">

                    <div :class="{'invalid-feedback':response.errorMessage.post_code}" v-if="response.errorMessage.post_code">
                        {{response.errorMessage.post_code[0]}}
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label for="state" class="sr-only">State</label>
                    <select class="form-control"
                            v-model="buildingInfo.state"
                            v-bind:class="{ 'is-invalid': error.buildingInformation.state }">
                        <option selected disabled value="">Choose...</option>
                        <option v-for="state in ['NSW', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'ACT', 'NT', 'SINGAPORE']" :value="state">{{state}}</option>
                    </select>

                    <div :class="{'invalid-feedback':response.errorMessage.state}" v-if="response.errorMessage.state">
                        {{response.errorMessage.state[0]}}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-12 mb-3">
                    <label for="key" class="sr-only">Key</label>
                    <textarea class="form-control" name="key" v-model="buildingInfo.key"
                              v-bind:class="{'is-invalid':error.buildingInformation.key}" placeholder="Key"></textarea>

                    <div :class="{'invalid-feedback':response.errorMessage.key}" v-if="response.errorMessage.key">
                        {{response.errorMessage.key[0]}}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-12 mb-3">
                    <label for="parking" class="sr-only">Parking</label>
                    <textarea class="form-control" name="parking" v-model="buildingInfo.parking"
                              v-bind:class="{'is-invalid':error.buildingInformation.parking}"
                              placeholder="Parking"></textarea>

                    <div :class="{'invalid-feedback':response.errorMessage.parking}" v-if="response.errorMessage.parking">
                        {{response.errorMessage.parking[0]}}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-12 mb-3">
                    <label for="toilet" class="sr-only">Toilets</label>
                    <textarea class="form-control" name="toilet" v-model="buildingInfo.toilet"
                              v-bind:class="{'is-invalid':error.buildingInformation.toilet}"
                              placeholder="toilet"></textarea>

                    <div :class="{'invalid-feedback':response.errorMessage.toilet}" v-if="response.errorMessage.toilet">
                        {{response.errorMessage.toilet[0]}}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-12 mb-3">
                    <label for="note" class="sr-only">Note</label>
                    <textarea name="note" placeholder="Note" v-model="buildingInfo.note"
                              v-bind:class="{'is-invalid':error.buildingInformation.note}"
                              class="form-control"></textarea>
                </div>
            </div>

            <h5>EMIoT only information</h5>
            <div class="form-row">
                <div class="col-md-12 mb-3">
                    <label for="contract_no" class="sr-only">Contract No</label>
                    <input type="text" class="form-control" name="contract_no" v-model="buildingInfo.contract_no"
                           v-bind:class="{'is-invalid':error.buildingInformation.contract_no}" placeholder="Contract Number">
                    <div :class="{'invalid-feedback':response.errorMessage.contract_no}" v-if="response.errorMessage.contract_no">
                        {{response.errorMessage.contract_no[0]}}
                    </div>
                </div>
            </div>
            <div class="form-row form-check">
                <div class="col-md-12 mb-3">
                    <label class="form-check-label">
                        <input class="form-check-input"
                               type="checkbox"
                               v-model="buildingInfo.inner"/>
                        WBS TECH inner building
                    </label>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-12 mb-3">
                    <select class="form-control d-block" v-model="buildingInfo.email_template" required>
                        <option disabled readonly :value="''">Select Email Template</option>
                        <option value="emiot">EMIoT managed building (WBS tech will fix the problem)</option>
                        <option value="3rd_party">3rd party managed building (WBS tech will not fix the problem)</option>
                    </select>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-12 mb-3">
                    <button type="submit" class="btn btn-primary btn-block" v-bind:disabled="isSubmitting">Submit</button>
                </div>
            </div>
        </form>
        <div class="form-row">
            <div class="col-md-12 mb-3">
                <transition name="fade">
                    <slot v-if="response.isSuccess" name="SuccessMessage"></slot>
                </transition>
            </div>
        </div>
    </div>
</template>
<style scoped>

    .disabledGoogleLocationInput {
        display: none;
    }
    .google-map.loaded {
        width: 100%;
        height: 300px;
        position: relative;
        overflow: hidden;
    }

</style>
<script>
  import GoogleMapsApiLoader from 'google-maps-api-loader';
  import ConnectionService from '../../app-model/model';

  const connectionService = new ConnectionService()

  export default {
    props: {
      buildingInformation: Object,
      apiMethod: Object
    },
    data () {
      return {
        buildingInfo: this.buildingInformation,
        googleLocationInput: '',
        google: null,
        map: null,
        mapInitialized: false,
        isSubmitting: false,
        response: {
          isSuccess: false,
          isFailed: false,
          message: '',
          errorMessage:''
        },
        timerForm: undefined,
        error: {
          buildingInformation: []
        }
      }
    },
    computed: {
    },
    created () {
      this.removeTimer();
    },
    beforeDestroy () {
      this.removeTimer();
    },
    methods: {
      removeTimer: function () {
        clearTimeout(this.timerForm);
      },
      prefillData: function(place) {
        let latitude, longitude, address, suburb, post_code, state;

        if(place.name) {
          address = place.name;
        }

        if (place.address_components) {
          for(let i in place.address_components) {
            let location = place.address_components[i];
            switch(true) {
              case location.types.indexOf('locality') > -1 && location.types.indexOf('political') > -1:
                suburb = location.short_name;
                break;
              case location.types.indexOf('administrative_area_level_1') > -1 && location.types.indexOf('political') > -1:
                state = location.short_name;
                break;
              case location.types.indexOf('postal_code') > -1:
                post_code = location.short_name;
                break;
            }
          }
        }

        if (place.geometry) {
          latitude = place.geometry.location.lat();
          longitude = place.geometry.location.lng();
        }

        Object.assign(this.buildingInfo, {
          latitude,
          longitude,
          address,
          suburb,
          post_code,
          state,
        });
      },
      loadGoogleMaps: async function () {
        let latitude = -33.8688, longitude = 151.2195;

        if(this.buildingInfo.latitude) {
          latitude = this.buildingInfo.latitude;
        }

        if(this.buildingInfo.longitude) {
          longitude = this.buildingInfo.longitude;
        }

        const googleMapApi = await GoogleMapsApiLoader({
          apiKey: window.GOOGLE_MAP_API_KEY,
          libraries: ['places']
        });
        this.google = googleMapApi;
        this.map = new this.google.maps.Map(
          this.$refs.googleMap,
          {
            center: {
              lat: latitude,
              lng: longitude
            },
            zoom: 17,
            gestureHandling: 'cooperative'
          }
        );

        let top = this,
          autocomplete = new this.google.maps.places.Autocomplete(this.$refs.googleMapInput),
          marker = new this.google.maps.Marker({
            map: this.map,
            anchorPoint: new this.google.maps.Point(0, -29)
          }),
          map = this.map;

        if(this.buildingInfo.latitude && this.buildingInfo.longitude) {
          marker.setPosition({
            lat: latitude,
            lng: longitude
          });
          marker.setVisible(true);
        }

        // Bind the map's bounds (viewport) property to the autocomplete object,
        // so that the autocomplete requests use the current map bounds for the
        // bounds option in the request.
        autocomplete.bindTo('bounds', this.map);

        // Set the data fields to return when the user selects a place.
        autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);

        autocomplete.addListener('place_changed', function() {
          marker.setVisible(false);
          let place = autocomplete.getPlace();

          if (!place.geometry) {
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            window.alert("No details available for input: '" + place.name + "'");
            return;
          }

          // If the place has a geometry, then present it on a map.
          if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport);
          } else {
            map.setCenter(place.geometry.location);
            map.setZoom(17);  // Why 17? Because it looks good.
          }
          marker.setPosition(place.geometry.location);
          marker.setVisible(true);

          top.prefillData(place);
        });
      },
      createBuilding: function () {
        this.isSubmitting = true;
        return this.$store.dispatch('apiResult', {
          method: this.apiMethod.method,
          path: this.apiMethod.path,
          data: this.buildingInfo,
          path_template: this.apiMethod.path_template,
          section: this.apiMethod.section,
        }).then(response => {
          switch (response.status) {
            case 422:
              this.isSubmitting = false;
              this.response.errorMessage = response.data
              this.error.buildingInformation = []
              for (let field in response.data) {
                this.error.buildingInformation[field] = true
                if (field === 'strata_no') {
                  connectionService['responseInTime']({responseObject: this.response, value: 'isFailed', status: true})
                  this.response.message = response.data.strata_no[0]
                }
              }

              break;
            case 200:
              let id = response.data.id;
              let fnEMIoTUpdate = () => {
                clearTimeout(this.timerForm);
                return this.$store.dispatch('apiResult', {
                  method: 'PATCH',
                  path: 'api/buildings/' + id,
                  path_template: '/api/buildings/{id}',
                  data: {
                    contract_no: this.buildingInfo.contract_no,
                    inner: this.buildingInfo.inner,
                    email_template: this.buildingInfo.email_template,
                  },
                  section: 'emiot',
                }).then(response => {
                  switch (response.status) {
                    case 200:
                      this.$store.state.router.push({name: 'edit-building', params: { buildingId: id }});
                      this.isSubmitting = false;
                      break;
                    case 410:
                      this.timerForm = setTimeout(function() {
                        fnEMIoTUpdate();
                      }, 1000);
                      break;
                  }
                });
              };

              fnEMIoTUpdate();

              break
          }

          return response;
        })
      },
      clear: function (field) {
        delete this.error.buildingInformation[field];
        delete this.response.errorMessage[field];
      },
    }
  }

</script>